import modelEnhance from "@/utils/modelEnhance";
import http from "@/http"

const HttpDevice = http.tokiot.device;
const HttpPlanePicture = http.tokiot.sys.planePicture;

const tokiot = http.tokiot
export default modelEnhance({
    namespace: "homeModal",
    state: {
        selectDeviceInfo: { visible: false },
        selectUnitInfo: { visible: false },
        selectMenuInfo: { visible: false },
    },
    subscriptions: {

    },
    effects: {
        * selectDeviceChange({ selectDevice }, { call, put }) {
            let selectDeviceInfo = selectDevice;
            if (!selectDeviceInfo) selectDeviceInfo = {};
            if (selectDeviceInfo.visible === undefined) selectDeviceInfo.visible = false;
            if (selectDeviceInfo.visible)
                yield put({ type: "selectUnitChange" });
            yield put({ type: "commonSetState", payload: { selectDeviceInfo } });
        },
        * selectUnitChange({ selectUnit }, { call, put }) {
            let selectUnitInfo = selectUnit;
            if (!selectUnitInfo) selectUnitInfo = {};
            if (selectUnitInfo.visible === undefined) selectUnitInfo.visible = false;
            if (selectUnitInfo.visible)
                yield put({ type: "selectDeviceChange" });
            yield put({ type: "commonSetState", payload: { selectUnitInfo } });
        },
        * selectMenuChange({ selectMenu }, { call, put }) {
            let selectMenuInfo = selectMenu;
            if (!selectMenuInfo) selectMenuInfo = {};
            if (selectMenuInfo.visible === undefined) selectMenuInfo.visible = false;
            if (selectMenuInfo.visible)
                yield put({ type: "selectDeviceChange" });
            if (selectMenuInfo.visible)
                yield put({ type: "selectUnitChange" });
            yield put({ type: "commonSetState", payload: { selectMenuInfo } });
        },
        * changeAlarmInfoVisible({ data }, { put }) {
            let alarmInfo = null;
            if (data) {
                alarmInfo = data;
            } else {
                alarmInfo = { visible: false }
            }
            yield put({ type: "commonSetState", payload: { alarmInfo } });
        },
        * changeUnitSelectVisible({ }, { put, select }) {
            let unitSelectVisible = yield select(state => state.commonModel.unitSelectVisible);
            unitSelectVisible = !unitSelectVisible;
            yield put({ type: "commonSetState", payload: { unitSelectVisible } });
        },
        * selectUnit({ payload }, { put, select }) {
            let selectUnit = yield select(state => state.commonModel.selectUnit);
            let unit1 = payload ? payload.id : undefined;
            let unit2 = selectUnit ? selectUnit.id : undefined;
            let get = unit1 !== unit2;
            selectUnit = payload;
            yield put({ type: "commonSetState", payload: { selectUnit } });
            if (get)
                yield put({ type: 'getUnitList' });
        },
        * getUnitList({ }, { call, put, select }) {
            let unit = yield select(state => state.commonModel.selectUnit);
            let data = {};
            if (unit && unit.id)
                data.id = unit.id;
            const ret = yield call(tokiot.sys.unit.v2.tree, data || {});
            if (ret) {
                let json = JSON.stringify(ret)
                    .replace(/name/g, "title")
                    .replace(/id/g, "value")
                    .replace(/childrenList/g, "children");
                let formatUnitTree = (tree, disType) => {
                    tree && tree.length && tree.forEach(item => {
                        if (disType === "Unit") {
                            item.children = item.children.filter(f1 => f1.type !== `Unit`)
                            formatUnitTree(item.children, disType);
                        } else {
                            item.disabled = disType === item.type;
                            formatUnitTree(item.children, disType);
                        }
                    })
                }
                let unitList = [JSON.parse(json)];
                let unitListOnlyOrgans = [JSON.parse(json)];
                let unitListOnlyUnit = [JSON.parse(json)];
                formatUnitTree(unitListOnlyUnit, "Organs");
                formatUnitTree(unitListOnlyOrgans, "Unit");
                yield put({ type: "commonSetState", payload: { unitList, unitListOnlyOrgans, unitListOnlyUnit } });
            }
        }
    },
    reducers: {
        commonSetState(state, { payload }) {
            return { ...state, ...payload };
        },
    }
});